import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle } from "lucide-react";

export default function CommentSection({ articleId }) {
  const [comments, setComments] = useState([]);
  const [name, setName] = useState("");
  const [body, setBody] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get(`/comments/${articleId}`);
      setComments(data);
    } catch { /* noop */ }
  };
  useEffect(() => { load(); }, [articleId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!name.trim() || !body.trim()) {
      toast.error("పేరు మరియు వ్యాఖ్య తప్పనిసరి");
      return;
    }
    setSubmitting(true);
    try {
      const { data } = await api.post("/comments", { article_id: articleId, author_name: name, body });
      toast.success(data.message || "సమర్పించబడింది");
      setName(""); setBody("");
    } catch (e) {
      toast.error(e.response?.data?.detail || "సమర్పణ విఫలం");
    } finally { setSubmitting(false); }
  };

  return (
    <section className="mt-16 border-t border-[#E5E4DC] pt-10 nv-selectable" data-testid="comments-section">
      <h3 className="font-heading-te text-2xl font-bold flex items-center gap-2 mb-6">
        <MessageCircle className="w-5 h-5 text-[#2E7D32]" />
        వ్యాఖ్యలు ({comments.length})
      </h3>

      <form onSubmit={submit} className="border border-[#E5E4DC] bg-white p-5 mb-8" data-testid="comment-form">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="మీ పేరు"
          className="w-full border border-[#E5E4DC] px-3 py-2 font-body-te mb-3 focus:outline-none focus:border-[#2E7D32]"
          data-testid="comment-name-input"
        />
        <textarea
          value={body}
          onChange={(e) => setBody(e.target.value)}
          placeholder="మీ అభిప్రాయం ఇవ్వండి..."
          rows={4}
          className="w-full border border-[#E5E4DC] px-3 py-2 font-body-te mb-3 focus:outline-none focus:border-[#2E7D32]"
          data-testid="comment-body-input"
        />
        <div className="flex items-center justify-between flex-wrap gap-2">
          <p className="text-xs text-[#4A4A4A] font-body-te">
            వ్యాఖ్యలు Admin ఆమోదం తర్వాత ప్రచురిస్తారు.
          </p>
          <button
            type="submit"
            disabled={submitting}
            className="bg-[#2E7D32] text-white px-5 py-2 font-body-te font-semibold hover:bg-[#1B5E20] disabled:opacity-60"
            data-testid="comment-submit-btn"
          >
            {submitting ? "సమర్పిస్తోంది..." : "సమర్పించండి"}
          </button>
        </div>
      </form>

      {comments.length === 0 ? (
        <p className="font-body-te text-[#4A4A4A]" data-testid="no-comments">మొదటిగా మీరే వ్యాఖ్యానించండి.</p>
      ) : (
        <ul className="space-y-4">
          {comments.map((c) => (
            <li key={c.id} className="border-l-4 border-[#2E7D32] bg-white px-4 py-3" data-testid={`comment-${c.id}`}>
              <div className="font-heading-te font-bold">{c.author_name}</div>
              <div className="text-xs text-[#4A4A4A] mb-1">
                {new Date(c.created_at).toLocaleString("te-IN")}
              </div>
              <p className="font-body-te text-[15px]">{c.body}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
